import { defineMessages, type MessageDescriptor } from 'react-intl'
import {
  TOUR_V2_PACKAGE_OPTION_BASE,
  TOUR_V2_PACKAGE_OPTION_EXTENDED,
  TOUR_V2_PACKAGE_OPTION_EXTENDED_ALTERNATIVE,
} from 'constants/tours'

export const FLIGHT_PACKAGE_TOUR_IDS = [
  'tour-dfbb7970-030b-4ba8-8c6d-b2fc83e3979d',
  'tour-5a0f5867-9627-450f-8eb2-ff137f83effc',
  'tour-f58e5071-bdfb-427e-896e-6a5432fab544',
  'tour-20cce463-48a2-421e-a224-1b4c2d49bad0',
  'tour-1078a19a-d91a-4788-8ee5-089f6e432e4f',
  'tour-148444fc-c9d0-4fc0-8f72-f3279bee361c',
] as const

// These tours need cabin-class labels rather than the generic Base/Extension
// labels. Keep the display override separate from the booking option names.
const flightPackageVariationLabels = defineMessages({
  [TOUR_V2_PACKAGE_OPTION_BASE]: {
    id: 'UnfGFHM_QqnNcniNDNaT',
    defaultMessage: 'Economy',
    description: 'Tour option label for the economy flight package on this tour',
  },
  [TOUR_V2_PACKAGE_OPTION_EXTENDED]: {
    id: 'jgO9C9OmoDQ2e_jgo6iy',
    defaultMessage: 'Economy Plus',
    description: 'Tour option label for the economy plus flight package on this tour',
  },
  [TOUR_V2_PACKAGE_OPTION_EXTENDED_ALTERNATIVE]: {
    id: 'MPFDzS1pPVI94Ix7gxVk',
    defaultMessage: 'Business Class',
    description: 'Tour option label for the business class flight package on this tour',
  },
})

const tourVariationLabelOverrides: Partial<Record<string, Partial<Record<string, MessageDescriptor>>>> =
  Object.fromEntries(FLIGHT_PACKAGE_TOUR_IDS.map((tourId) => [tourId, flightPackageVariationLabels]))

export default tourVariationLabelOverrides
